module.exports = __webpack_public_path__ + "img/sx-2.193cc520.png";